import { __awaiter } from "tslib";
import axios from 'axios';
import { API_KEY, API_URL } from './api';
const cache = new Map();
const checkSingleEmail = (email, log) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!cache.has(email)) {
        const result = yield axios.get(`${API_URL}?api=${API_KEY}&email=${email}`);
        if (result.data) {
            cache.set(email, result.data);
        }
    }
    //if the call is failing, assume we should accept it (send_transactional)
    const returnValue = (_a = cache.get(email)) !== null && _a !== void 0 ? _a : { debounce: { send_transactional: '1' }, success: '0' };
    log === null || log === void 0 ? void 0 : log.info('checkSingleEmail', returnValue);
    return returnValue;
});
export default checkSingleEmail;
//# sourceMappingURL=checkSingleEmail.js.map